import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { SelectCentroCostoNivel2 } from 'sharedComponents/select'

const CentroCostoNivel2FormGroup = ({ iError, iTouched, fIsSubmitting, idNodoPadre }) => {
  return (
    <Form.Group>
      <Form.Label text='CENTRO NIVEL 2' htmlFor='select-centroCostoNivel2' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idCentroCostoNivel2'>
          {({ field }) => (
            <SelectCentroCostoNivel2
              {...field}
              id='select-centroCostoNivel2'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              idNodoPadre={idNodoPadre}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CentroCostoNivel2FormGroup)
